module.exports = __webpack_public_path__ + "img/594.b3164803.jpg";